import React, { Component } from "react";
import {
  Card,
  Form,
  Button,
  Input,
  Select,
  message,
  Divider,
  Typography,
  Space,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import LinkButton from "../../components/link-button";
import PicturesWall from "./pictures-wall";

import storageUtils from "../../utils/storageUtils";
import {
  req_options_cfs_term,
  req_add_applycase,
  req_edit_applycase,
  req_list_cfs_computerroom,
} from "../../api";

const Item = Form.Item;
const { Option } = Select;

export default class MyApplyCaseModify extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    options: [],
    rooms: [],
    newItem: "",
    items: ["螢幕損壞", "鍵盤損壞", "滑鼠損壞", "主機損壞", "作業系統異常"],
    isButtonDisabled: false,
    seconds: 5,
  };

  constructor(props) {
    super(props);
    //獲取子組件(pictures-wall)實體方法
    this.cfspicturesfiles = React.createRef();
  }

  UNSAFE_componentWillMount() {
    // 取出協帶的數據(來自product)
    const applycase = this.props.location.state;
    //console.log(applycase)
    this.isUpdate = !!applycase;
    this.applycase = applycase || {};
    //this.api_list_computerrooms();
  }

  componentDidMount() {
    this.api_list_rooms();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_rooms = async () => {
    const token = storageUtils.getUser().token;
    const result = await req_options_cfs_term("Room", token);
    if (result.total > 0) {
      const categorys = result.data;
      this.initOptions(categorys);
    }
  };

  api_list_computerrooms = async () => {
    const token = storageUtils.getUser().token;
    const result = await req_list_cfs_computerroom(token);
    console.log(result);
    if (result.total > 0) {
      const rooms = result.data;
      this.setState({ rooms });
    } else {
      this.setState({ rooms: [] });
    }
  };

  api_modify_applycase = async (applycase) => {
    if (applycase.RoomCode === "0000") {
      message.error("請選擇教室");
    } else {
      if (this.isUpdate) {
        applycase.Uid = this.applycase.Uid;
        applycase.CaseNid = this.applycase.CaseNid;
        applycase.condition = "BASE";
        //console.log(applycase)
        const result = await req_edit_applycase(
          applycase,
          storageUtils.getUser().token
        );
        if (result.status === "success") {
          // console.log(result)
          message.success(result.message);
          this.props.history.goBack();
        } else {
          message.error(result.message);
        }
      } else {
        const result = await req_add_applycase(
          applycase,
          storageUtils.getUser().token
        );
        if (result.status === "success") {
          message.success(result.message);
          this.props.history.goBack();
        } else {
          message.error(result.message);
        }
      }
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  initOptions = async (categorys) => {
    const options = categorys.reduce((row_pre, row) => {
      row_pre.push({ value: row.value, label: row.label });
      return row_pre;
    }, []);
    this.setState({ options });
    //console.log(options)
  };

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = (values) => {
    //console.log('Success:', values);
    const CreatorCode = storageUtils.getUser().userCode;
    const CaseStatus = "PENDING_CASE";
    const { CaseContent, RoomCode, ComputerCode } = values;

    // console.log(this.picturesfiles)
    const images = this.cfspicturesfiles.current.output_files();
    const Appendices = images.reduce((item_pre, item) => {
      item_pre.push({ Uid: item });
      return item_pre;
    }, []);
    const applycase = {
      CaseContent: CaseContent,
      RoomCode: RoomCode,
      ComputerCode: ComputerCode,
      Appendices: Appendices,
      CreatorCode: CreatorCode,
      CaseStatus: CaseStatus,
    };
    this.api_modify_applycase(applycase);

    this.setState({
      isButtonDisabled: true,
    });

    this.countSeconds = setInterval(this.timerCount, 1000);
    setTimeout(() => {
      this.setState({ isButtonDisabled: false, seconds: 5 });
      clearInterval(this.countSeconds);
    }, 5000);
  };

  onNameChange = (event) => {
    this.setState({ newItem: event.target.value });
  };

  addItem = (e) => {
    e.preventDefault();
    const { items, newItem } = this.state;
    items.push(newItem);
    this.setState(items);
  };

  handleDescriptChange = (value) => {
    this.setState({
      selectedDescription: value,
    });
  };

  countDown = (seconds) => {
    return seconds;
  };

  timerCount = () => {
    var setCount = this.countDown(this.state.seconds);
    if (setCount) {
      this.state.seconds
        ? this.setState({ seconds: this.state.seconds - 1 })
        : this.setState({ seconds: this.state.seconds });
    }
  };

  ///////////////////////////////////////////////////////////

  render() {
    const { options, items, isButtonDisabled } = this.state;
    const { isUpdate, applycase } = this;
    const fileUrlPath = "/api/ComputerMaintainAppendix/AddFile";
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };

    const title = (
      <span>
        <LinkButton>
          <ArrowLeftOutlined
            style={{ color: "green", marginRight: 15, fontSize: 20 }}
            onClick={() => this.props.history.goBack()}
          />
        </LinkButton>
        案件{isUpdate ? "修改" : "新增"}
      </span>
    );

    return (
      <Card title={title} className="my-apply-case-modify">
        <Form
          {...formItemLayout}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Item
            label="電腦教室"
            name="RoomCode"
            initialValue={isUpdate ? applycase.RoomCode : "0000"}
          >
            <Select>
              <Option value="0000">請選擇電腦所在教室</Option>
              {options.map((row) => (
                <Option value={row.value.toString()} key={row.value}>
                  {row.label}
                </Option>
              ))}
            </Select>
          </Item>
          <Item
            label="電腦編號"
            name="ComputerCode"
            initialValue={applycase.ComputerCode}
            rules={[
              { required: true, whitespace: true, message: "必須填寫電腦編號" },
            ]}
          >
            <Input placeholder="輸入電腦編號" />
          </Item>
          <Item
            label="異常問題"
            name="CaseContent"
            initialValue={applycase.CaseContent}
            rules={[
              {
                required: true,
                whitespace: true,
                message: "必須說明電腦異常問題",
              },
            ]}
          >
            <Select
              style={{ width: "100%" }}
              onChange={this.handleDescriptChange}
              placeholder="請輸入異常問題"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space align="center" style={{ padding: "0 8px 4px" }}>
                    <Input
                      placeholder="自述異常問題"
                      onChange={this.onNameChange}
                    />
                    <Typography.Link
                      onClick={this.addItem}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <span className="btn btn-sm btn-warning">
                        <i className="fas fa-plus"></i> 增加
                      </span>
                    </Typography.Link>
                  </Space>
                </>
              )}
            >
              {items.map((item) => (
                <Option key={item}>{item}</Option>
              ))}
            </Select>
          </Item>
          <Item label="附加圖片" name="Appendices">
            <PicturesWall
              ref={this.cfspicturesfiles}
              edit_input_images={applycase.Appendices}
              upload_urlpath={fileUrlPath}
            ></PicturesWall>
          </Item>
          <Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={isButtonDisabled}
            >
              {isUpdate ? "重新" : "送出"}申請{" "}
              {isButtonDisabled ? this.state.seconds : ""}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}
